export default "__VITE_ASSET__BZzn7KJO__"